import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Label from 'components/_utility/Label';
import {
  getRequiresSingleChoice,
  getRequiresAccessories,
  getPendingAccessories,
  getPack,
} from 'src/redux/bike/selectors';
import AccessoryChoiceGroup from 'components/AccessoryChoiceGroup/AccessoryChoiceGroup';
import { setRequiresSingleChoice, closeRequiredResolution, closeAccessoryResolution, resolveAccessoriesRequired, resolveAccessoryPackConflict } from 'src/redux/bike/actions';
import Scrollbar from 'react-scrollbars-custom';
import { Wrap, Heading, Title, Description, Actions, ConfirmButton, CancelButton } from '../ConflictingAccessories/ConflictingAccessories.styled';
import { accessoryItemsSelector } from 'src/redux/configurator/selectors';

const RequiredAccessories = () => {
  const dispatch = useDispatch();

  const { requiresAll, requiresSingle } = useSelector(getRequiresAccessories);
  const requiresSingleChoice = useSelector(getRequiresSingleChoice);
  const pendingAccessories = useSelector(getPendingAccessories);
  const noRequiresSingleChoice = requiresSingle.length === 1 || !requiresSingle.length;
  const pack = useSelector(getPack);
  const packPartIds = (pack && pack.parts.map(accessory => accessory.id)) || [];
  const accessories = useSelector(accessoryItemsSelector);

  useEffect(() => {
    // skip required screen if it's a pack item that requires an accessory and
    // that accessory isn't in the pack
    if (!pendingAccessories.length || !pendingAccessories[0].pack) {
      return;
    }

    const packRequiresAll = requiresAll.filter(accessory => packPartIds.includes(accessory.id));
    const packRequiresSingle = requiresSingle.filter(accessory => packPartIds.includes(accessory.id));

    // pack should have all of its requirements included so don't keep resolution flow going
    if (!packRequiresAll.length && !packRequiresSingle.length) {
      dispatch(closeRequiredResolution());
    }
  }, [dispatch, packPartIds, pendingAccessories, requiresAll, requiresSingle]);

  return (
    <Wrap>
      <Title>
        <Label name="requiredAccessoryTitle" />
      </Title>
      <Description>
        <Label name="requiredAccessoryDescription" />
      </Description>
      <Scrollbar noDefaultStyles>
        {requiresSingle.length && requiresSingle.length > 1 ? (
          <>
            <Heading>
              <Label name="requiresSingleLabel" />
            </Heading>
            {requiresSingle.map(accessory => {
              const selected = requiresSingleChoice && accessory.id === requiresSingleChoice.id;
              return (
                <AccessoryChoiceGroup
                  id={accessory.id}
                  accessories={[accessory]}
                  onChoose={() => dispatch(setRequiresSingleChoice(selected ? null : accessory.id))}
                  selected={selected}
                />
              );
            })}
          </>
        ) : null}
        {requiresAll.length || noRequiresSingleChoice ? (
          <>
            <Heading>
              <Label name={noRequiresSingleChoice ? 'accessoriesLabel' : 'requiresAllLabel'} />
            </Heading>
            <AccessoryChoiceGroup
              id="new"
              accessories={requiresAll.concat(noRequiresSingleChoice && requiresSingle[0] ? requiresSingle[0] : [])}
              noChoice
            />
          </>
        ) : null}

        <Actions>
          <ConfirmButton primary onClick={() => dispatch(resolveAccessoriesRequired({ accessories }))}><Label name="confirmLabel"></Label></ConfirmButton>
          <CancelButton onClick={() => dispatch(closeAccessoryResolution())}><Label name="cancelLabel"></Label></CancelButton>
        </Actions>
      </Scrollbar>
    </Wrap>
  );
};

export default RequiredAccessories;
